import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { getAvailableTypes } from 'helpers/documentManagerApi';
import DocumentList from './DocumentList';
import DocumentForm from './DocumentForm';
import DocumentDetail from './DocumentDetail';

const DocumentManager = ({ patient_id, facilityid }) => {
  const [view, setView] = useState('list'); // 'list', 'create', 'edit', 'detail'
  const [selectedDocId, setSelectedDocId] = useState(null);
  const [availableTypes, setAvailableTypes] = useState([]);
  const [loadingTypes, setLoadingTypes] = useState(true);

  // Fallbacks for patient context from localStorage
  const activePatientId = patient_id || localStorage.getItem('patientId');

  useEffect(() => {
    const fetchTypes = async () => {
      try {
        setLoadingTypes(true);
        const res = await getAvailableTypes();
        if (res && res.status) {
          setAvailableTypes(res.data || []);
        } else {
          toast.error(res?.message || 'Failed to fetch available document types');
        }
      } catch (err) {
        console.error(err);
        toast.error('Error fetching available document types');
      } finally {
        setLoadingTypes(false);
      }
    };

    fetchTypes();
  }, []);

  const handleNavigate = (newView, docId = null) => {
    setView(newView);
    setSelectedDocId(docId);
  };

  const renderView = () => {
    switch (view) {
      case 'create':
        return (
          <DocumentForm
            patientId={Number(activePatientId)}
            facilityId={Number(facilityid)}
            availableTypes={availableTypes}
            onCancel={() => handleNavigate('list')}
            onSuccess={() => handleNavigate('list')}
          />
        );
      case 'edit':
        return (
          <DocumentForm
            patientId={Number(activePatientId)}
            facilityId={Number(facilityid)}
            documentId={selectedDocId}
            availableTypes={availableTypes}
            onCancel={() => handleNavigate('list')}
            onSuccess={() => handleNavigate('list')}
          />
        );
      case 'detail':
        return (
          <DocumentDetail
            documentId={selectedDocId}
            onBack={() => handleNavigate('list')}
            onEdit={() => handleNavigate('edit', selectedDocId)}
          />
        );
      case 'list':
      default:
        return (
          <DocumentList
            patientId={Number(activePatientId)}
            availableTypes={availableTypes}
            loadingTypes={loadingTypes}
            onView={(id) => handleNavigate('detail', id)}
            onEdit={(id) => handleNavigate('edit', id)}
            onCreate={() => handleNavigate('create')}
          />
        );
    }
  };

  return (
    <div className="document-manager-container mt-3">
      {renderView()}
    </div>
  );
};

DocumentManager.propTypes = {
  patient_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  facilityid: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default DocumentManager;
